import axiosBase, { AxiosError } from 'axios';
import { User } from '../contexts/UserContext';

export const isCancel = axiosBase.isCancel;
export const CancelToken = axiosBase.CancelToken;
export const loginPath = '/login';
export const axiosKK = axiosBase.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

function setToken() {
  const storedUser = localStorage.getItem('user');
  const userObject = storedUser && JSON.parse(storedUser);

  if (userObject) {
    axiosKK.defaults.headers.common['Authorization'] =
      'bearer ' + userObject.token;
  }
}
setToken();

function updateStoredUser(newState: (user: User) => any) {
  const storedUser = localStorage.getItem('user');
  const userObject = storedUser && JSON.parse(storedUser);
  if (userObject) {
    const updatedUser = newState(userObject);
    localStorage.setItem('user', JSON.stringify(updatedUser));
  }
}

// Module-level guard so concurrent 401s don't fire multiple
// `window.location.assign` calls (admin pages issue many parallel requests).
let isRedirectingToLogin = false;

axiosKK.interceptors.response.use(
  (response) => {
    const updatedToken = response.data.jwt;
    if (updatedToken) {
      axiosKK.defaults.headers.common['Authorization'] =
        'bearer ' + updatedToken;

      updateStoredUser((user) => {
        user.token = updatedToken;

        return user;
      });

      // delete response.data.jwt;
    }

    const requestId = response.headers['x-request-id'];
    if (requestId) {
      localStorage.setItem('last_request_id', requestId);
    }

    return response;
  },
  function (error: AxiosError) {
    const status = error.response?.status;

    const requestId = error.response?.headers?.['x-request-id'];
    if (requestId) {
      localStorage.setItem('last_failed_request_id', requestId as string);
    }

    if (status === 401) {
      updateStoredUser((user) => {
        delete user.token;

        return user;
      });
      if (window.location.pathname !== loginPath && !isRedirectingToLogin) {
        isRedirectingToLogin = true;
        window.location.assign(loginPath);
      }
    }

    return Promise.reject(error);
  },
);
